import { ShipmentInfoRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class ShipmentInfoService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ShipmentInfoRouteService());
	}

	find = filter => {
		const url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	};

	updateShipmentInfoByTrackingNumber = (shipmentInfo, sourceOfChange) => {
		const url = this.routeService.updateShipmentInfoByTrackingNumber(shipmentInfo, sourceOfChange);
		return this.apiClient.put(url, shipmentInfo);
	};

	updateShipmentInfo = (shipmentInfo, revertFulfillmentOrderStatus, sourceOfChange) => {
		const url = this.routeService.update(shipmentInfo, revertFulfillmentOrderStatus, sourceOfChange);
		return this.apiClient.put(url, shipmentInfo);
	};

	exportLabels = (carrierTypeId, serviceTypeId, dateTime) => {
		const url = this.routeService.exportLabels(carrierTypeId, serviceTypeId, dateTime);
		return this.apiClient.get(url);
	};

	// Old labeling mode.
	getFulfillmentOrderShipment = (upc, sourceOfChange) => {
		const url = this.routeService.getFulfillmentOrderShipment(upc, sourceOfChange);
		return this.apiClient.get(url);
	};

	// New labeling mode.
	createOrGetShipment = (createOrGetShipmentParams, sourceOfChange) => {
		const url = this.routeService.createOrGetShipment(createOrGetShipmentParams, sourceOfChange);
		return this.apiClient.post(url, createOrGetShipmentParams);
	};

	removeFromPallet = requestContent => {
		const url = this.routeService.removeFromPallet(requestContent);
		return this.apiClient.put(url);
	};

	scanTrackingNumber = requestContent => {
		const url = this.routeService.scanTrackingNumber();
		return this.apiClient.post(url, requestContent);
	};

	createBuyShippingShipmentInfo = shipmentInfo => {
		const url = this.routeService.createBuyShippingShipmentInfo(shipmentInfo);
		return this.apiClient.post(url, shipmentInfo);
	};

	bulkPrint = (bulkPrintFulfillmentOrders, sourceOfChange) => {
		var url = this.routeService.bulkPrint(bulkPrintFulfillmentOrders, sourceOfChange);
		return this.apiClient.post(url, bulkPrintFulfillmentOrders);
	};

	undoPalletize = (shipmentInfo, sourceOfChange) => {
		const url = this.routeService.undoPalletize(shipmentInfo, sourceOfChange);
		return this.apiClient.put(url, shipmentInfo);
	};

	reprintLabel = (shipmentInfoId, getLabel) => {
		const url = this.routeService.reprintLabel(shipmentInfoId, getLabel);
		return this.apiClient.put(url, shipmentInfoId);
	};

	voidLabel(voidLabelParams, voidOption, sourceOfChange) {
		const url = this.routeService.voidLabel(voidOption, sourceOfChange);
		return this.apiClient.post(url, voidLabelParams);
	}

	undoLabelCreated(undoLabelCreatedParams, sourceOfChange) {
		const url = this.routeService.undoLabelCreated(undoLabelCreatedParams, sourceOfChange);
		return this.apiClient.post(url, undoLabelCreatedParams);
	}

	createReturnLabel = returnLabelParams => {
		var url = this.routeService.createReturnLabel(returnLabelParams);
		return this.apiClient.post(url, returnLabelParams);
	};
}

export default ShipmentInfoService;



// WEBPACK FOOTER //
// ./src/common/data/services/ShipmentInfoService.js